import script from "./compWorkflowsStatsPanel.vue?vue&type=script&setup=true&lang=js"
export * from "./compWorkflowsStatsPanel.vue?vue&type=script&setup=true&lang=js"

import "./compWorkflowsStatsPanel.vue?vue&type=style&index=0&id=06648ac0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-06648ac0"]])

export default __exports__